import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import { ReactComponent as ProviderIcon } from '../../../../../assets/icons/Navegation/proveedores.svg';
import { ReactComponent as SubmenuIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import { headerTitleStyle, icons, triangle } from '../Styles/StylesIcons';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import GenericListItemButton from './MenuItemWithSubmenu';

const TriangleIcon = (props) => <SubmenuIcon style={triangle} {...props} />;

const SuppliersMenu = ({
  userPermissions,
  paymentSuppliers,
  handleOpenSuppliers,
  activeStyle,
  drawerOpen,
  header,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='LIST_PAYMENTS'
          to='/transacciones/netpay'
          title='NetPay'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='LIST_PAYMENTS'
          to='/transacciones/stp'
          title='STP'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='LIST_PAYMENTS'
          to='/transacciones/toku'
          title='Toku'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='LIST_PAYMENTS'
          to='/transacciones/openpay'
          title='OpenPay'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='LIST_PAYMENTS'
          to='/transacciones/mercadopago'
          title='Mercado Pago'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='LIST_PAYMENTS'
          to='/transacciones/stripe'
          title='Stripe'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <GenericNavListItem
          userPermissions={userPermissions}
          permission='LIST_PAYMENTS'
          to='/transacciones/yuno'
          title='Yuno'
          IconComponent={TriangleIcon}
          activeStyle={activeStyle}
        />
      )}
    </>
  );

  return (
    <>
      {userPermissions?.includes('LIST_PAYMENTS') && (
        <>
          <Divider style={{ margin: '0 0 4px 0' }} />
          {drawerOpen && (
            <>
              {header?.transactions.kind === 'header' && (
                <div style={headerTitleStyle}>{header.transactions.title}</div>
              )}
            </>
          )}
          <GenericListItemButton
            onClick={drawerOpen ? handleOpenSuppliers : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='Dalefon'
            IconComponent={(props) => <ProviderIcon style={icons} {...props} />}
            openMenu={paymentSuppliers}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={paymentSuppliers}
              userPermissions={userPermissions}
            >
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default SuppliersMenu;
